import type { FC } from "react";
import { useGoalsRight } from "web_myplann/Api/Rights/RightsProvider";
import { SettingsPage } from "web_myplann/Profile/Pages/SettingsPage";
import { SettingsV2Page } from "web_myplann/Profile/Pages/SettingsV2Page";

export const SettingsPageResolver: FC = () => {
	const hasGoalsRight = useGoalsRight();

	return hasGoalsRight ? <SettingsV2Page /> : <SettingsPage />;
};
